if (typeof G == 'undefined') G = {};

G.StateMachine = function StateMachine(initialState, transitionsMap) {

  // imports
  var utils = G.Utils;

  //

  var currentState = initialState;
  var transitionSignal = new Phaser.Signal();

  return {
    isInState: isInState,
    transit: transit,
    transitIfPossible: transitIfPossible,
    canTransitTo: canTransitTo,
    transitionSignal: transitionSignal
  };

  function isInState(state) {
    return currentState === state;
  }

  function canTransitTo(newState) {
    var currentlyPossibleTransitions = transitionsMap[currentState];
    return (
      currentlyPossibleTransitions &&
      currentlyPossibleTransitions.indexOf(newState) >= 0
    );
  }

  function transit(newState, optPayload) {
    if (!transitIfPossible(newState, optPayload)) {
      utils.debugError("Transition not allowed: " + currentState + " -> " + newState);
    }
  }

  function transitIfPossible(newState, optPayload) {
    if (canTransitTo(newState)) {
      changeState(newState, true, optPayload);
      return true;
    } else {
      return false;
    }
  }

  function changeState(newState, optDispatch, optPayload) {
    var oldState = currentState;
    currentState = newState;
    if (optDispatch) {
      transitionSignal.dispatch(newState, oldState, optPayload);
    }
  }
};
